import { ReactNode, lazy, Suspense } from "react";
import { useParams } from "react-router";
import cardTemplate from "@/static/images/whitelabel_card_template.png";
import mcgriffCard from "../../themes/Mcgriff/discount-card.png";
import { ThemeSelectorContext } from "./ThemeSelectorContext";

import { ALLOW_CLIENT_LIST } from "@/constants/allowClientList";

const Caprx = lazy(async () => await import("@/themes/Caprx"));
// const Cdphp = lazy(async () => await import("@/themes/Cdphp"));

const Mcgriff = lazy(async () => await import("@/themes/Mcgriff"));

interface ThemeSelectorProps {
  children: ReactNode;
}

interface UrlParams {
  client?: string;
}

export const ThemeSelector = ({ children }: ThemeSelectorProps) => {
  const { client }: UrlParams = useParams();

  let clientName = undefined;

  // CapRx theme is the main theme
  let theme = <Caprx />;
  let clientDisplayName = "Capital Rx";
  let card = cardTemplate;
  let groupNumber = "1";

  // Make sure client name is not undefined
  if (client && ALLOW_CLIENT_LIST.includes(client?.toString())) {
    clientName = client?.toString();

    if (client === "mcgriff") {
      theme = <Mcgriff />;
      clientDisplayName = "McGriff";
      card = mcgriffCard;
      groupNumber = "13";
    }
  }

  return (
    <ThemeSelectorContext.Provider
      value={{ client: clientName, clientDisplayName: clientDisplayName, card: card, groupNumber: groupNumber }}
    >
      <Suspense fallback={null}>{theme}</Suspense>
      {children}
    </ThemeSelectorContext.Provider>
  );
};
